"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.One = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const OneSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M7.25 22.5h12.5a.75.75 0 0 0 .75-.75V7.5h.75a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-.75v-.25a.75.75 0 0 0-.75-.75H7.25a.75.75 0 0 0-.75.75v19.5c0 .413.337.75.75.75M7 2.25A.25.25 0 0 1 7.25 2h12.5a.25.25 0 0 1 .25.25v.25a.5.5 0 0 0 .5.5h.75a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25h-.75a.5.5 0 0 0-.5.5v14.25a.25.25 0 0 1-.25.25H7.25a.25.25 0 0 1-.25-.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M21.25 7a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25h-.75a.5.5 0 0 1-.5-.5v-.25a.25.25 0 0 0-.25-.25H7.25a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25h12.5a.25.25 0 0 0 .25-.25V7.5a.5.5 0 0 1 .5-.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#7719AA",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F9F7F7",
    d: "M4.602 10h1.627l2.88 4.352L9.094 10h1.29v6h-1.56l-2.92-4.278c.024.184.035 4.278.035 4.278H4.602z"
  })]
});
const One = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: OneSvg
}));
exports.One = One;